//
// Copyright (c) 2024 Emplifi, Inc.
//

import { Command, Editor } from "ckeditor5";

export type SnippetCommandOptions = {
  snippetId?: string | null | undefined;
  snippetName?: string | null | undefined;
};

export default class SnippetCommand extends Command {
  declare public snippetName: string | null | undefined;
  declare public value: string | null | undefined;

  constructor(editor: Editor) {
    super(editor);
    this.set({
      snippetName: null,
    });
  }

  execute(options?: SnippetCommandOptions | undefined) {
    if (!this.value && !options) {
      return;
    }

    const executeOptions: SnippetCommandOptions = {
      snippetId: this.value,
      snippetName: this.snippetName,
      ...options,
    };

    if (!executeOptions.snippetName) {
      executeOptions.snippetName = this.editor.config.get("snippet.emptyName") as string;
    }
    const model = this.editor.model;
    model.change((writer) => {
      const snippet = writer.createElement("snippet", executeOptions);
      model.insertContent(snippet);
      writer.setSelection(snippet, "on");
    });
  }

  refresh() {
    const model = this.editor.model;
    const selection = model.document.selection;
    const element = selection.getSelectedElement();
    if (element && element.is("element", "snippet")) {
      this.isEnabled = true;
      this.value = element.getAttribute("snippetId") as string | null | undefined;
      this.snippetName = element.getAttribute("snippetName") as string | null | undefined;
    } else {
      const currentPosition = selection?.getFirstPosition();
      const allowedIn = currentPosition
        ? model.schema.findAllowedParent(currentPosition, "snippet")
        : false;

      this.isEnabled = !!allowedIn;
      this.value = "";
      this.snippetName = "";
    }
  }
}
